











































































































































import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import { SelectOptionList } from '@/models/api/payment/parameter/type/user-select'
import { PaymentList } from '@/models/api/payment/payment'
import { LegacyEngineSubscriptionHistory } from '@/models/api/subscription/legacy-engine-subscription-history'

import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { PaymentType } from '@/models/app-config/behavior/types'
import { CartItemList } from '@/models/cart/cart-item'
import { CartScopeEq } from '@/models/cart/group/scope'
import { CartItemRepository } from '@/models/cart/repository/cart-item-repository'
import RemoveItemFromCartService from '@/models/cart/service/remove-item-from-cart-service'
import { UpdateItemCountInCartService } from '@/models/cart/service/update-item-count-in-cart-service'
import * as CurrentTime from '@/models/current-time/functions'
import { getDefaultDeliveryTime } from '@/models/delivery'
import { AppliedPoint, DiscountAmount, DiscountPrice } from '@/models/discount-amount/discount-amount'
import { OrderResult } from '@/models/order/completed/order-result'
import { SubscriptionApplyingItem } from '@/models/order/subscription/applying-item/subscription-applying-item'
import {
  SubscriptionApplyingItemFindBySkuRepository,
} from '@/models/order/subscription/applying-item/subscription-applying-item-repository'
import {
  convertFromCartItemToSubscriptionCartItem,
  SubscriptionCartItem,
} from '@/models/order/subscription/subscription-cart-item'
import { AfterPurchaseProcessStatus } from '@/models/purhase/after-purchase-process-status'
import { convertToApplyBundleDiscountParamter } from '@/services/api/bundle-discount'
import PaymentService from '@/services/api/payment'
import { buildFrequencyWithSomeDelayedHourAndMinutesFrom, SubscriptionService } from '@/services/api/subscription'
import {
  parametersWhichAreRequiredByEngineForSubscription,
} from '@/services/api/subscription/payment/parameters-which-are-required-by-engine-for-subscription'
import { PaymentServiceForSubscription } from '@/services/api/subscription/payment/payment-service-for-subscription'
import { Frequency } from '@/services/api/subscription/subscription-apply'
import { getCreditcardPaymentProvierServiceConfig } from '@/services/payment'
import {
  CreditcardPaymentProviderServiceForSubscription,
} from '@/services/payment/creditcard-payment-provider/creditcard-payment-provider-service'
import OptionsValidator from '@/services/payment/options-validator'
import { CreditcardPayment } from '@/services/payment/types'
import { EventBusForThirdParty } from '@/usecases/event-bus-for-third-party/event-bus'
import { adCodeStore } from '@/util/adcode/store'
import { allRight } from '@/util/either-list'
import { formatPrice } from '@/util/format'
import { InstanceResolver } from '@/util/instanceResolver'
import { OperationMode, operationModes } from '@spa/components/organisms/cart/model/item/operation-mode'
import ContactViewItem from '@spa/components/organisms/contact/ViewItem.vue'
import TimeSlotSelect from '@spa/components/organisms/order/delivery/TimeSlotSelect.vue'
import OrderCarat from '@spa/components/organisms/order/OrderCarat.vue'
import PaymentViewItem from '@spa/components/organisms/order/payment/ViewItem.vue'
import TotalPrice from '@spa/components/organisms/order/TotalPrice.vue'
import SecurityCodeForm from '@spa/components/organisms/payment/creditcard/SecurityCodeForm.vue'
import DeliveryConfigList from '@spa/components/pages/order/edit/delivery/DeliveryConfigList.vue'
import { OrderContext } from '@spa/components/pages/order/model/context/order-context'
import * as InconsistentError from '@spa/components/pages/order/model/error-message/inconsistent-error'
import { getPaymentErrorMessage } from '@spa/components/pages/order/model/error-message/payment-error'
import { AtoneScriptLoader, PaidyScriptLoader } from '@spa/components/pages/order/model/payment/payment-script-loader'
import { convertFromOrderPurchaseResult, createRedirectHtmlRenderer } from '@spa/components/pages/order/order/redirect-html-renderer'
import { guardOnCart, guardOnDelivery, guardOnUser } from '@spa/components/pages/order/routing/guard'
import NoteSubscriptionRange from '@spa/components/pages/subscription/apply-subscription/NoteSubscriptionRange.vue'
import { log } from '@spa/log'
import { PluginMixin } from '@spa/mixins/plugin'
import { FrontPriceSection, PurchaseEstimate, PurchaseService } from '@spa/services/api/purchase'
import {
  atoneAuthenticatedCallbackFactory,
  atoneCancelledCallbackFactory,
  atoneErrorCallbackFactory,
  atoneFailedCallbackFactory,
  atoneSucceededCallbackFactory,
  configAtone,
  convertCartItems as convertCartItemsForAtone,
  makeAtonePayment,
} from '@spa/services/atone'
import {
  extractFrontErrorBodiesFromPurchaseResult,
  kind as OrderKind,
  Order as OrderItem,
  OrderPurchaseFail,
  OrderPurchaseResult,
  OrderService,
} from '@spa/services/order'
import {
  configPaidy,
  convertCartItems as convertCartItemsForPaidy,
  makePaidyPayload,
  paidyCallbackFactory,
  PaidyResponse,
} from '@spa/services/paidy'
import store from '@spa/store'
import { LoadAppSettingParameter } from '@spa/store/modules/appSetting/actions'
import { LoadWithScopePayload } from '@spa/store/modules/cart/actions'
import { isSubscriptionApplicable } from '@spa/store/modules/cart/function'
import { CartItem } from '@spa/store/modules/cart/types'
import { Contact } from '@spa/store/modules/contact/types'
import { LoadPayload } from '@spa/store/modules/creditcard/actions'
import { Delivery, OrderConfirmState, Payment, } from '@spa/store/modules/orderConfirm/types'
import { StoredDelivery } from '@spa/store/modules/subscriptionConfirm'
import { SetCompletedState } from '@spa/store/modules/subscriptionConfirm/action'
import { User } from '@spa/store/modules/user/types'

import dateFormat from 'date-fns/format'
import { Either, left, Left, right, Right } from 'fp-ts/lib/Either'
import _ from 'lodash'
// https://www.npmjs.com/package/vue-bootstrap-datetimepicker#usage-example
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.min.css'
import DatePicker from 'vue-bootstrap-datetimepicker' // TODO: This package requires 'moment', which has large size
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { Location } from 'vue-router'
import { setupPaymentInitializationSpec } from '../order/model/payment/initialization'
import { PaymentInitializationSpec } from '../order/model/payment/initialization/specification'
import { toQuery } from '../order/scope-transpiler'
import OrderConfirmList from './apply-subscription/OrderConfirmList.vue'
import OrderPrice from './apply-subscription/OrderPrice.vue'
import {
  buildAppliedSubscriptionRecordFromLegacyData,
  DeliveryContactForOrderHistoryFromStoreDeliveryContact,
} from './completed/build-applied-subscription-record-from-legacy-data'

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
])

@Component({
  components: {
    DatePicker,
    ContactViewItem,
    PaymentViewItem,
    TimeSlotSelect,
    OrderCarat,
    OrderConfirmList,
    OrderPrice,
    SpaErrorDialog,
    TotalPrice,
    SecurityCodeForm,
    DeliveryConfigList,
    NoteSubscriptionRange,
  },
})
export default class ApplySubscription extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ required: true })
  skuId: string

  @Prop({ required: true })
  scope: CartScopeEq

  @Prop({ required: true })
  behavior: BehaviorConfig

  @Prop({ required: true })
  purchaseService: PurchaseService

  @Prop({ required: true })
  orderService: OrderService

  @Prop({ required: true })
  cartItemRepository: CartItemRepository

  @Prop({ required: true })
  subscriptionService: SubscriptionService

  @Prop({ required: true })
  subscriptionApplyingItemRepository: SubscriptionApplyingItemFindBySkuRepository

  @Prop({ required: true })
  context: OrderContext

  /**
   * context とは分けて定義しておく
   * @see https://github.com/my-color/front/pull/5375#discussion_r657632297
   */
  readonly operationMode: OperationMode = operationModes.onlyChangeCount

  /**
   * TODO: appSetting取得をstoreから取り除いたら削除
   * brandを算出する代わりに、appSettingServiceをDIする
   * @deprecated
   * @see https://github.com/my-color/front/pull/2027
   */
  get brandEnglishName(): string | null {
    return this.scope.kind.isBrand ? this.scope.value.toString() : null
  }

  status: Status = Status.Pending
  orderStatus: Status = Status.Pending

  estimateStatus: Status = Status.Pending

  showModal: boolean = false

  modalMessage: string = ''

  purchaseMenu: any = null

  purchaseEstimates: PurchaseEstimate[] = []

  deliveryDate: number = 1

  /**
   * 配送時間帯の初期値を設定
   *
   * この値はエンジンまたは配送業者に依存するため、MCフロント側で持つべき知識ではない。
   * しかし、現状（2021.03.08）ではMCフロント側で持たざるを得ない。
   * 配送時間帯を指定しないあるいは指定不可の時は、この初期値を設定して注文しなければならない。
   * 詳細はこちら: https://github.com/my-color/front/pull/4959#pullrequestreview-606007153
   */
  deliveryTimeSlot: string = getDefaultDeliveryTime().id
  selectedTimeSlotLabel: string = getDefaultDeliveryTime().label

  securityCode: string = ''

  currentTime = CurrentTime.create()

  datepickerOption = {
    locale: 'ja',
    format: 'YYYY/M/DD',
    useCurrent: 'day',
    minDate: this.currentTime.now,
    maxDate: this.currentTime.now,
    dayViewHeaderFormat: 'YYYY年 MM月',
  }

  provisionalOrderIdForSingleOrder: string | null = null

  paymentService = new PaymentServiceForSubscription(new PaymentService())
  availablePaymentList: PaymentList = PaymentList.empty()

  atoneScriptLoader: AtoneScriptLoader = new AtoneScriptLoader()

  paidyScriptLoader: PaidyScriptLoader = new PaidyScriptLoader()

  paidyHandler: PaidyHandler

  errorMessage: string = 'エラーが発生しました。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'

  errorMessageInPurchase: string = 'エラーが発生しました。<br/>決済手続きは完了しておりません。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'

  subscriptionApplyingItem: SubscriptionApplyingItem | null = null

  get cardPaymentProviderConfig() {
    return getCreditcardPaymentProvierServiceConfig()
  }
  get cardPaymentProvider(): CreditcardPaymentProviderServiceForSubscription {
    return this.cardPaymentProviderConfig.forSubscription
  }

  async onChangeCount(updated: SubscriptionCartItem, newCount: number): Promise<void> {
    try {
      await this.$store.dispatch('view/startLoading')

      const id = updated.id

      await this.$store.dispatch('cart/updateUnitCount', {
        id,
        unitCount: newCount,
        updateItemCount: UpdateItemCountInCartService.create(this.cartItemRepository),
      })

      const item = this.$store.getters['cart/getItem'](id)

      if (_.get(item, 'error.update')) {
        this.modalMessage = 'エラーが発生しました。<br/>数量の変更に失敗しました'
        this.showModal = true
      } else {
        await this.loadPurchaseEstimate()
      }
    } catch (error) {
      log.error({ error })

      this.modalMessage = 'エラーが発生しました。<br/>お問い合わせより、カスタマーセンターへお問い合わせください。'
      this.showModal = true

    } finally {
      await this.$store.dispatch('view/stopLoading')
    }
  }

  get deliveryPlan() {
    // FIXME
    return _.get(this.purchaseEstimates[0], 'deliveryPlan')
  }

  get isLoading(): boolean {
    return this.$store.state.view.isLoading
  }

  /**
   * TODO: `get cartItems` に統合する. getter 内部で適用されている filter は、利用側で直接適用する形になるか.
   * @deprecated
   * @see https://github.com/my-color/front/pull/5321#discussion_r627687378
   */
  get displayCartItems(): SubscriptionCartItem[] {
    const cartItems: CartItem[] = this.$store.getters['cart/displayItemsWithFilter'](isSubscriptionApplicable)

    return cartItems
      .filter(c => c.skuId === this.skuId)
      .reduce(
        (ls: SubscriptionCartItem[], next: CartItem): SubscriptionCartItem[] => {
          return convertFromCartItemToSubscriptionCartItem(next).fold(
            (error) => {
              // 不正な商品があったら、ログを出しつつ無視して処理として停止させない
              // 過去の傾向から、不正なデータが有った場合に処理を止めることよりも
              // 正常なデータに限っては処理を続行可能とすることが優先されてきたため
              log.warn(`cart ${next.id} is ignored because ${error.message}`)

              return ls
            },
            converted => ls.concat(converted)
          )
        },
        []
      )
  }
  get displayTotalItemCount(): number {
    return _.sumBy(this.displayCartItems, item => _.toNumber(item.unitCount))
  }

  get cartItems(): SubscriptionCartItem[] {
    const cartItems: CartItem[] = this.$store.getters['cart/itemsWithFilter'](isSubscriptionApplicable)

    return cartItems.filter(c => c.skuId === this.skuId)
      .reduce(
        (ls: SubscriptionCartItem[], next: CartItem): SubscriptionCartItem[] => {
          return convertFromCartItemToSubscriptionCartItem(next).fold(
            (error) => {
              // 不正な商品があったら、ログを出しつつ無視して処理として停止させない
              // 過去の傾向から、不正なデータが有った場合に処理を止めることよりも
              // 正常なデータに限っては処理を続行可能とすることが優先されてきたため
              log.warn(`cart ${next.id} is ignored because ${error.message}`)

              return ls
            },
            converted => ls.concat(converted)
          )
        },
        []
      )
  }

  get displayOrderList(): OrderItem[] {
    return this.orderService.createOrderFromCartItems(this.displayCartItems, this.deliveryDateForStandardOrder)
  }

  get orderList(): OrderItem[] {
    return this.orderService.createOrderFromCartItems(this.cartItems, this.deliveryDateForStandardOrder)
  }

  get canScheduleDelivery(): boolean {
    return this.$store.getters['appSetting/scheduledDelivery']
  }

  get deliveryDateForStandardOrder(): string {
    return this.deliveryDate === null ? '未指定' : dateFormat(this.deliveryDate, 'YYYY年MM月DD日')
  }

  get cartIds(): string[] {
    return _.map(this.cartItems, item => item.id)
  }

  async cancel() {
    log.info('cancel subscription-apply with removing the subscription cart item')
    const removeItemFromCartService = RemoveItemFromCartService.create(this.cartItemRepository)
    const target = this.cartItems.find(c => c.skuId === this.skuId)

    await this.$store.dispatch('view/startLoading')

    if (target) {
      await this.$store.dispatch('cart/remove', {
        id: target.id,
        removeItemFromCartService,
      }).then(() => {
        log.info('succeed remove the subscription cart item')
      }).catch(() => {
        log.warn('failed remove the subscription cart item, but ignore because user action should not be blocked')
      })
    } else {
      log.warn(`try to remove cart item for ${this.skuId} for cancel but not found, so ignore`)
    }

    /**
     * ブランドTOPへ帰す
     * @see https://github.com/my-color/front/issues/5627#issuecomment-919665095
     */
    location.href = this.brandTopPage
    // ページ遷移するのでローディング停止は省略
  }

  get brandTopPage(): string {
    return InstanceResolver.isSingle() ? '/' : `/${this.brandEnglishName}`
  }

  get orderConfirm(): OrderConfirmState {
    return this.$store.state.orderConfirm
  }

  get delivery(): Delivery | null {
    return this.orderConfirm.delivery
  }

  get deliveryContact(): Contact | null {
    if (!this.delivery) {
      return null
    }

    const { id } = this.delivery

    return this.$store.getters['contact/get'](id)
  }

  get errorOnContactLoad() {
    return _.get(this.$store.state.contact.error, 'load')
  }

  get payment(): Payment | null {
    return this.orderConfirm.payment
  }

  get paymentType(): PaymentType | undefined {
    return _.get<Payment, 'payment_type'>(this.payment, 'payment_type')
  }

  /**
   * server側でも同様の条件により、支払い方法をnoneに強制セットしている。
   * @see src/Parameter/CommercePurchase/Post.php #buildRequestWithPaymentTypeNoneIfSomeSatisfied
   * もっとも、noneはclientがリクエストすべきことで、serverは受け取ったnoneをバリデーションするに止め、支払い方法の強制セットを控えるべきという考え方もある。
   * その辺りはserverにロジックを収納していく過程で検討したい。
   *
   * またこのメソッドは、2022/01/17現在、client上で支払い方法をnoneにセットしているわけ「ではない」。
   * 本来はclientでの表示の段階で、ユーザにnoneであることを見せる方が望ましいようにも思う。
   * その要望があれば今後対応を検討する。なおその時、クーポンをつけたり外したりして、noneでなくなった時にどう見せるか（元の支払い方法を記憶していてそこに戻るか）
   * ということも考慮しなければならない。
   */
  get isFullyDiscountedExceptForPayment(): boolean {
    // Depending on estimated prices
    if (_.isEmpty(this.purchaseEstimates)) {
      return false
    }

    return this.totalPrice <= this.commission
  }

  // TODO: Move to domain model
  get paymentTypeIsUserSide(): boolean {
    return _.includes(['atone', 'paidy'], this.paymentType)
  }

  get errorOnPurchaseLoad() {
    return _.get(this.$store.state.purchase.error, 'load')
  }

  get user(): User {
    return this.$store.state.user.user
  }

  get errorOnAppSettingLoad() {
    return _.get(this.$store.state.appSetting, 'error.load')
  }

  get isFreeShipping(): boolean {
    return this.$store.getters['cart/isFreeShippingOnCatalogOnlyWithFilter'](isSubscriptionApplicable)
  }

  // TODO: Use the defined type more elsewhere
  // TODO: Convert to FrontPriceSection type in advance
  get estimatedPriceSections(): FrontPriceSection[] {
    return this.purchaseEstimates.map(estimate => estimate.price as FrontPriceSection)
  }

  get subtotalPrice(): number {
    return _.sum(this.subtotalPriceList)
  }

  get subtotalPriceList(): number[] {
    return _.map(this.purchaseEstimates, 'price.order.priceIncludingTax.price').filter(price => price > 0)
  }

  get commission(): number {
    return _.sum(this.commissionList)
  }
  get commissionList(): number[] {
    return _.map(this.purchaseEstimates, 'price.payment.priceNoTax.price').filter(price => price > 0)
  }

  get shipping(): number {
    return this.isFreeShipping ? 0 :_.sum(this.shippingList)
  }

  get shippingList(): number[] {
    return _.map(this.purchaseEstimates, 'price.delivery.priceIncludingTax.price').filter(price => price > 0)
  }

  get totalPrice(): number {
    return _.sum(_.map(this.purchaseEstimates, 'price.total'))
  }

  get discountAmount(): DiscountAmount {
    return new DiscountAmount(
      DiscountPrice.valueOf(this.discountPrice),
      AppliedPoint.zero() // 定期購入申し込みではポイント適用は考慮しない
    )
  }

  get discountPrice(): number {
    return Math.min(this.estimatedDiscountPrice, this.subtotalPrice)
  }

  // Use estimated response value.
  // This MAY not be the same as a real discount, because discount is applied to each order's subtotal price.
  get estimatedDiscountPrice(): number {
    return _.sumBy(this.estimatedPriceSections, priceSection =>
      priceSection.discount ? priceSection.discount.total.amount : 0
    )
  }

  get tax(): number {
    return _.sum(_.map(this.purchaseEstimates, 'price.tax'))
  }

  get orderButtonIsEnabled(): boolean {
    const paymentType = _.get<Payment, 'payment_type'>(this.payment, 'payment_type')

    if (paymentType === 'atone' && !this.atoneScriptLoader.loaded) {
      return false
    }

    if (paymentType === 'paidy' && !this.paidyScriptLoader.loaded) {
      return false
    }

    return this.estimateStatus === Status.Completed &&
      this.status === Status.Pending &&
      this.orderStatus === Status.Pending
  }

  get showSecurityCode(): boolean {
    return this.paymentType === 'creditcard'
      && this.cardPaymentProviderConfig.viewConfig.paymentForm.requireSecurityCode
  }

  setReplacedForSale(flag: boolean) {
    this.$store.commit('cart/isReplacedForSale', flag)
  }

  formatPrice(price: number): string {
    return formatPrice(price)
  }

  disableDeliverySchedule() {
    log.warn('disabling delivery schedule')
  }

  /**
   * Member fileds payment, delivery and cartIds MUST be loaded in advance
   */
  async initPurchaseEstimate() {
    await this.loadPurchaseEstimate()
  }

  /**
   * This value is watched for sending /commerce_purchase_estimate.
   */
  get stringOfEstimateVariableConditions(): string {
    return JSON.stringify({
      ...this.delivery && { delivery: this.delivery },
      discountPrice: 0,
    })
  }

  /**
   * FIXME: Vue watch of object with { deep : true } somehow triggeres again and again,
   * even though the object's primitive values are remains the same.
   * In particular, watch to 'discountPrice' will be triggered when 'purchaseEstimates' is re-substituted,
   * because 'discountPrice' refers to 'subtotalPrice' which then refers to 'purchaseEstimates'.
   * For the solution: watch the stringified value, not the object itself.
   *
   * See: https://github.com/my-color/front/pull/2104#issuecomment-521156229
   */
  @Watch('stringOfEstimateVariableConditions')
  async updatePurchaseEstimate() {
    if (_.isEmpty(this.purchaseEstimates)) {
      return  // Skip until estimate is initiated.
    }

    await this.loadPurchaseEstimate()
  }

  async loadPurchaseEstimate() {
    // TODO: Refactoring
    if (!this.payment || !this.delivery || _.isEmpty(this.cartIds)) {
      return
    }

    // Load purchaseEstimate
    // TODO maybe separate delivery date by order
    const [preOrders, standardOrders] = _.partition(this.orderList, o => o.kind === OrderKind.PreOrder)
    const getEstimate = (order: OrderItem) => {
      const cartIds = _.map(order.cartItems, 'id')

      return this.purchaseService.getEstimate(
        // 'estimate' parameter
        {
          cartIds: (cartIds || []).join(','),
          payment: this.payment!,
          deliveryId: _.get(this.delivery!, 'id'),
          deliveryMethod: _.get(this.delivery!, 'deliveryMethod'),
          unattendedDelivery: null,
        },
        convertToApplyBundleDiscountParamter(order.cartItems)
      )
    }

    /* Start calling */
    this.estimateStatus = Status.Loading

    /* Call API */
    const purchaseEstimates = await Promise.all([
      ...standardOrders.map(getEstimate),
      ...preOrders.map(getEstimate),
    ])

    if (!allRight(purchaseEstimates)) {
      this.estimateStatus = Status.Failed

      /**
       * 構築されるメッセージが不明瞭だが、
       * 長ったらしいエラーメッセージをもう一度書き直したくないので……
       */
      this.modalMessage = `支払情報の取得中に${this.errorMessage}`
      this.showModal = true

      return
    }

    this.purchaseEstimates = purchaseEstimates.map(pe => pe.value)

    // TODO maybe separate delivery date by order
    // Promsie#allは呼び出し維持の順番を保持するので、0番目＝通常の注文に対するestimate
    const date = this.purchaseEstimates[0].deliveryPlan.date
    const { year, month, day } = date

    const beginOfDeliverable = 1
    const endOfDeliverable = 7

    this.datepickerOption.minDate = new Date(year, month - 1, day + beginOfDeliverable)
    this.datepickerOption.maxDate = new Date(year, month - 1, day + endOfDeliverable)

    this.estimateStatus = Status.Completed
  }

  get purchaseParamsBase(): { delivery: Delivery, frequency: Frequency, cartScope: CartScopeEq, adCode?: string } {
    const delivery = this.delivery!
    const frequency: Frequency = buildFrequencyWithSomeDelayedHourAndMinutesFrom(new Date())
    const maybeAdCode = adCodeStore.read()

    return {
      delivery,
      frequency,
      ...maybeAdCode.map<{ adCode?: string }>(adCode => ({ adCode })).getOrElse({}),
      cartScope: this.scope,
    }
  }

  async created() {
    this.status = Status.Loading
    // Avoid spinner to be stopped because other page's LoadingMixin can call 'view/stopLoading'
    await store.dispatch('view/startLoading')

    try {
      await this.init()

      this.status = Status.Pending
    } catch (error) {
      log.error(error)

      // 初期化がそもそも失敗した場合、待機中ではなく続行不可の状態に陥ったとみなす
      this.status = Status.Failed
    } finally {
      // Stop ViewState loading, which is started from beforeRouteEnter
      await store.dispatch('view/stopLoading')
    }

    EventBusForThirdParty.getInstance().publish('page-initialized', {
      url: window.location.href,
      initializedAt: CurrentTime.create().now,
      user: this.user,
    })
  }

  async initAppSetting(): Promise<void> {
    const param: LoadAppSettingParameter = {
      brand: this.brandEnglishName,
    }
    await this.$store.dispatch('appSetting/load', param)

    if (this.errorOnAppSettingLoad) {
      this.disableDeliverySchedule()
    }
  }

  async init(): Promise<void> {
    const resultOfGuard = await this.guardBeforeInitialize()
    if (resultOfGuard.isLeft()) {
      log.warn(`guard before initialize failed, finally redirect to`, resultOfGuard.value)

      return
    }

    await Promise.all([
      this.initPurchaseMenu(),
      this.initCart(),
      this.initUser(),
      this.initContact(),
      this.initCreditcard(),
      this.initAppSetting(),
      this.subscriptionApplyingItemRepository.findBySku(this.skuId).then((s) => {
        this.subscriptionApplyingItem = s
      }),
    ])

    // TODO: Comment on why and how these methods depend on the above, or refactor to take explicit arguments.
    await Promise.all([
      this.initDelivery(),
      this.initDeliveryDate(),
      this.loadCreditcardScript(),
      this.initAvailablePaymentList(),
    ])
    await this.initPayment()

    const path = this.guardBeforePurchaseEstimate()

    if (path) {
      this.$router.push(path)

      return
    }

    await this.initPurchaseEstimate()

    // Presupposes that changing payment type always go through this order page initialization.
    // Only when payment type is 'atone', init atone script.
    // This process is done in async way so as not to delay the page rendering.
    // The status of atone script loading should be managed elsewhere.
    if (this.paymentType === 'atone') {
      this.loadAtoneScript()
    }

    // Presupposes that changing payment type always go through this order page initialization.
    // Only when payment type is 'paidy', init paidy script.
    // This process is done in async way so as not to delay the page rendering.
    // The status of paidy script loading should be managed elsewhere.
    if (this.paymentType === 'paidy') {
      this.loadAndConfigPaidyScript()
    }
  }

  async initPurchaseMenu(): Promise<void> {
    const purchaseMenu = await this.purchaseService.getMenu()

    if (purchaseMenu.isLeft()) {
      this.modalMessage = this.errorMessage
      this.showModal = true

      log.error({ message: 'failed init purchase menu', error: purchaseMenu.value })

      return
    }

    this.purchaseMenu = _.get(purchaseMenu.value, 'body.data')
  }

  async initCart(): Promise<void> {
    const payload: LoadWithScopePayload = {
      scope: this.scope,
    }

    return this.$store.dispatch('cart/loadWithScope', payload).then(() => {
      if (this.cartItems.length > 0) return Promise.resolve()

      this.modalMessage = [
        '定期購入の情報が取得できませんでした。',
        '前の画面に戻って改めて定期購入のお申し込みを開始いただくか、',
        '画面の再読み込みをお試しください',
        '',
        '※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。',
      ].join('<br>')
      this.showModal = true

      return Promise.reject(new Error(`subscription item ${this.skuId} not found in cart`))
    })
  }

  async initUser(): Promise<void> {
    await this.$store.dispatch('user/get', { force: true })
  }

  async initDelivery(): Promise<void> {
    if (this.delivery) {
      return
    }

    // TODO: Refactor to integrate
    await this.$store.dispatch('purchase/loadLatest')
    await this.$store.dispatch('contact/load')

    if (this.errorOnContactLoad) {
      this.modalMessage = this.errorMessage
      this.showModal = true
      this.status = Status.Failed

      log.error({ message: 'failed to init contact', error: this.errorOnContactLoad })

      return
    }

    // Check latest purchase for delivery
    const latestPurchase = this.$store.getters['purchase/latestOfPurchase']

    const latestPurchaseContact = this.$store.getters['contact/get'](
      _.get(latestPurchase, 'delivery.contact_id')
    )

    if (latestPurchaseContact) {
      await this.$store.dispatch('orderConfirm/initializeDelivery', { id: latestPurchaseContact.id })

      return
    }

    // Fallback: get display_level === 0 contact
    const firstContact: Contact = await this.$store.getters['contact/first']

    if (firstContact) {
      await this.$store.dispatch('orderConfirm/initializeDelivery', { id: firstContact.id })
    }
  }

  async initContact() {
    await this.$store.dispatch('contact/load')
  }

  /**
   * This methods requires that user and creditcards are all loaded in the store.
   */
  async initPayment(): Promise<void> {
    if (this.payment) {
      return
    }

    return (await this.paymentInitializationSpec.build()).fold(
      (error) => {
        log.error('error occured in initializing payment', error)

        this.modalMessage = this.errorMessage
        this.showModal = true
      },
      maybePayment => maybePayment.foldL(
        () => this.$router.push(this.context.path.editPayment),
        (paymentWithApiPayment) => {
          this.$store.dispatch('orderConfirm/setPayment', { payment: paymentWithApiPayment })
        }
      )
    )
  }
  get paymentInitializationSpec(): PaymentInitializationSpec {
    return setupPaymentInitializationSpec({
      purchaseService: new PurchaseService(),
      availablePaymentList: this.availablePaymentList,
      creditcardStore: {
        first: this.$store.getters['creditcard/first'],
        findById: id => this.$store.getters['creditcard/get'](id),
      },
      location,
    })
  }

  async initCreditcard() {
    const payload: LoadPayload = {
      service: this.context.factory.service.creditCard(),
    }
    await this.$store.dispatch('creditcard/load', payload)
  }

  async initAvailablePaymentList() {
    const cartIdList = _.map(this.cartItems, cart => cart.id)
    const result = await this.paymentService.get(cartIdList, {
      confirm_url: `${location.origin}/s/order/subscription/${this.skuId}?scope=${toQuery(this.scope)}`,
    })

    if (result.isLeft()) {
      this.modalMessage = 'エラーが発生しました。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
      this.showModal = true

      return
    }

    this.availablePaymentList = PaymentList.valueOf(result.value)
  }

  /**
   * NOTE: 配送日時選択不可あるいは未選択の状態で注文する場合は null と 0 という仕様
   * 詳細はこちら: https://github.com/my-color/front/pull/4959#pullrequestreview-606007153
   */
  async initDeliveryDate() {
    const deliveryDate = this.$store.state.orderConfirm.deliveryDate
    this.deliveryDate = _.get(deliveryDate, 'deliveryPlanDate', null)
    this.deliveryTimeSlot = _.get(deliveryDate, 'deliveryTimeSlot', '0')
  }

  guardBeforePurchaseEstimate(): string | null {
    const pathOnBlankField = this.guardBlankField()

    if (pathOnBlankField) {
      return pathOnBlankField
    }

    const pathOnUnselectablePaymentType = this.guardOnUnselectablePaymentType(
      // TODO: 前段でpaymentTypeの存在チェックが行われているが、そのことが暗黙的になってしまっている。
      this.paymentType!
    )

    if (pathOnUnselectablePaymentType) {
      return pathOnUnselectablePaymentType
    }

    return null
  }

  guardBlankField(): string | null {
    // Payment type
    if (!this.paymentType) {
      return this.context.path.editPayment
    }

    // Delivery
    if (!this.delivery || !this.deliveryContact) {
      return this.context.path.editContact
    }

    return null
  }

  guardOnUnselectablePaymentType(paymentType: string): string | null {
    if (!this.isAvailablePayment(paymentType)) {
      return this.context.path.editPayment
    }

    return null
  }

  isAvailablePayment(paymentType: string): boolean {
    return this.availablePaymentList.isAvailablePayment(paymentType)
  }

  async createProvisionalOrderIdForSingleOrderIfNotExist(): Promise<void> {
    if (this.provisionalOrderIdForSingleOrder) {
      return
    }

    const provisionalOrderIdResult = await this.purchaseService.createProvisionalOrderId()

    if (provisionalOrderIdResult.isLeft()) {
      return
    }

    this.provisionalOrderIdForSingleOrder = provisionalOrderIdResult.value
  }

  async order() {
    this.orderStatus = Status.Loading

    try {
      const validated = await this.validateOrder()

      if (!validated) {
        this.orderStatus = Status.Pending
        log.warn('validation failed')

        return
      }

      // paymentType will be set to 'none' on the server side based on the estimate.
      // Avoid user side purchase (atone, paidy) when 'none' will be set.
      if (this.paymentTypeIsUserSide && this.isFullyDiscountedExceptForPayment) {
        await this.processPurchaseDefault()
        this.orderStatus = Status.Pending

        return
      }

      switch (this.paymentType) {
        case 'atone':
          await this.processAtone()
          // Wheter an error occured or not, consequent process is delegated to Atone module callback.
          break
        case 'paidy':
          await this.processPaidy()
          // Wheter an error occured or not, consequent process is delegated to Atone module callback.
          break
        case 'creditcard':
          await this.processCreditcard()
          break
        // TODO: paymentTypeごとに分岐させる
        default:
          await this.processPurchaseDefault()
          break
      }

      this.orderStatus = Status.Pending
    } catch (error) {
      // 本当はここにモーダルだのエラーメッセージだのも集約したいが、
      // 既存実装がそれぞれの処理の中で勝手にやってるので、エラーログの出力保証までで一旦諦める.
      // 全部のエラーハンドリングを整理するまでの整理は
      // https://github.com/my-color/front/issues/5636 のついででは厳しい.
      log.error(error)

      // 決済処理中に何らかエラーが起きたとして、リトライの可能性を完全に潰すことは避ける
      this.orderStatus = Status.Pending
    }
  }

  /**
   * @return Whether order content is valid
   */
  async validateOrder(): Promise<boolean> {
    // TODO: More validation
    const validated = await this.$validator.validateAll()

    if (!validated) {
      this.modalMessage = '入力内容が正しくありません'
      this.showModal = true

      return false
    }

    // Validate payment
    if (!await this.validatePaymentAndPrice()) {
      return false
    }

    // Validate delivery
    if (!this.delivery) {
      this.modalMessage = '配送先が選択されていません'
      this.showModal = true

      return false
    }

    // Validate cart ids
    if (_.isEmpty(this.cartItems)) {
      this.modalMessage = 'お申込内容が見つかりませんでした'
      this.showModal = true

      return false
    }

    return true
  }

  /**
   * @return Whether selected payment and price is valid for user
   */
  async validatePaymentAndPrice(): Promise<boolean> {
    // Validate payment
    if (!this.payment) {
      this.modalMessage = '支払い方法が選択されていません'
      this.showModal = true

      return false
    }

    // 注文確認画面に入った段階で設定されている支払方法が利用可能か検査されているので通常は通ることのないルート
    // バグ、データの改ざん、決済手続き中に設定が変更されたなどのイレギュラーなケースをガードする目的
    if (!this.isAvailablePayment(this.payment.payment_type)) {
      this.modalMessage = 'ご利用いただけないお支払い方法です。他のお支払い方法を選択してください。'
      this.showModal = true

      return false
    }

    if (this.payment.apiPayment && !this.payment.apiPayment.parameters.isEmpty) {
      return !(new OptionsValidator(
        this.payment.apiPayment.parameters,
        this.payment.selectedOptionList || SelectOptionList.empty()
      )).validate().hasSomeError
    }

    return true
  }

  async processAtone(): Promise<void> {
    if (!Atone) {
      this.modalMessage = this.atoneScriptLoader.loadErrorMessage
      this.showModal = true

      log.error({ message: 'atone script not found' })

      return
    }

    await this.createProvisionalOrderIdForSingleOrderIfNotExist()

    if (!this.provisionalOrderIdForSingleOrder) {
      this.modalMessage = this.errorMessage
      this.showModal = true

      log.error({ message: 'atone required provisional order id, but not found' })

      return
    }

    if (!this.deliveryContact) {
      this.modalMessage = this.errorMessage
      this.showModal = true

      log.error({ message: 'atone required delivery contact, but not found' })

      return
    }

    const atonePaymentItems = convertCartItemsForAtone({
      items: this.cartItems,
      shipping: this.shipping,
      discountAmount: this.discountAmount,
    })
    const atonePaymentResult = await makeAtonePayment(
      this.provisionalOrderIdForSingleOrder,
      this.user,
      this.deliveryContact,
      atonePaymentItems
    )

    if (atonePaymentResult.isLeft()) {
      this.modalMessage =  this.errorMessage
      this.showModal = true

      log.error({ message: 'atone payment failed', error: atonePaymentResult.value })

      return
    }

    configAtone(
      this.user.id,
      {
        preToken: this.user.payment_auth_token || '',
        payment: atonePaymentResult.value,
        authenticated: this.atoneAuthenticatedCallback,
        cancelled: this.atoneCancelledCallback,
        failed: this.atoneFailedCallback,
        succeeded: this.atoneSucceededCallback,
        error: this.atoneErrorCallback,
      }
    )

    Atone.start()

    return
  }

  async executePurchase(
    params: {
      orders: OrderItem[],
      payment?: Payment,
      purchaseEstimates?: PurchaseEstimate[],
    }
  ): Promise<void> {
    const payment = params.payment || this.payment!
    payment.variableResource = {
      ...payment.variableResource,
      ...{ user: this.user },
    }

    const purchaseEstimates = params.purchaseEstimates || this.purchaseEstimates

    // Order[]とPurchaseEstimate[]は同じ順に対応するよう並んでいるのでforEachでマッピング可能
    // とは言え本来であればそれらの関連付けは堅牢に行われるべき。
    // OrderとPurchaseEstimateを1:1でマッピングするようなオブジェクトのうまみを検証し導入する、など
    const orders = params.orders
    orders.forEach((o: OrderItem, index: number) => {
      o.discount = {
        coupon: _.get(purchaseEstimates[index], 'price.discount.coupon', 0),
        bundle: _.get(purchaseEstimates[index], 'price.discount.bundle', 0),
      }
      o.estimatedPoints = _.get(purchaseEstimates[index], 'point.amount', 0)
    })

    await this.withPurchaseTransaction(async () => {
      // v1時点では決済の手続き周辺を俯瞰した設計をする余裕が無いので、
      // 一旦力任せで強引に通している
      //
      // もしもサブスク申込の拡張が要求されるなら、少なくとも1回は
      // 全体を俯瞰し再設計のタイミングを設けること.
      // 間違っても、現状の作りをそのまま拡張してはいけない.
      return await Promise.all(
        orders.map(
          order => this.subscriptionService.apply({
            scope: this.scope,
            order,
            payment,
            ...this.purchaseParamsBase,
          })
        )
      )
    })
  }

  async withPurchaseTransaction(executePurchase: () => Promise<OrderPurchaseResult[]>): Promise<void> {
    await this.$store.dispatch('view/startLoading')

    const purchaseResult = await executePurchase()
    const afterExecuteResult = await this.afterExecutePurchase(purchaseResult)

    afterExecuteResult.fold(
      async () => {
        await this.$store.dispatch('view/stopLoading')
      },
      async () => {
        this.$router.push(this.context.path.orderComplete)
        await this.$store.dispatch('view/stopLoading')
      }
    )
  }

  /**
   * @return Flag to continue code flow
   */
  async afterExecutePurchase(purchaseResult: OrderPurchaseResult[]): Promise<AfterPurchaseProcessStatus> {
    const [successOrders, failedOrders] = _.partition(purchaseResult, 'success')

    if (successOrders.length === 0) {
      if (this.shouldReload(purchaseResult)) {
        log.warn('reload because price of some items changed')

        // reload and detect item price changed in guardOnCart
        this.$router.go(0)

        return AfterPurchaseProcessStatus.failed()
      }

      log.warn('failed to apply subscription because some errors contained in result', purchaseResult)

      this.modalMessage = this.createPurchaseErrorMessage(purchaseResult)
      this.showModal = true

      return AfterPurchaseProcessStatus.failed()
    }

    if (this.redirectToPaymentIfNeed(purchaseResult)) {
      // リダイレクトが実行された場合にも、実際に遷移が完了するまでは後続の処理が実行されるので、
      // リダイレクトされたというステータスを返し処理を中断する
      return AfterPurchaseProcessStatus.redirected()
    }

    const historyResult = await this.subscriptionService
      .historyWhichIsEngineResourceViaLegacyProxy({ limit: successOrders.length })

    if (historyResult.isLeft()) {
      this.modalMessage = '申込に成功しましたが、申込履歴の取得に失敗しました'
      this.showModal = true

      return AfterPurchaseProcessStatus.failed()
    }

    const completedOrders: LegacyEngineSubscriptionHistory[] = historyResult.value
    await this.setCompleteData(completedOrders, failedOrders as OrderPurchaseFail[])

    await this.$store.dispatch('cart/load', { force: true })

    log.debug('#afterExecutePurchase completed')

    return AfterPurchaseProcessStatus.completed()
  }

  createPurchaseErrorMessage(purchaseResults: OrderPurchaseResult[]): string {
    const errorBodies = _.compact(purchaseResults.map((result) => {
      return _.get(result.error, 'response.body', null)
    }))
    const defaultErrorMessage = this.errorMessageInPurchase

    if (errorBodies.length === 0) {
      return defaultErrorMessage
    }

    const errorMessages = _.compact(errorBodies.map((body) => {
      switch (body['reason.code']) {
        // tslint:disable-next-line:no-magic-numbers
        case 16101:
          // tslint:disable-next-line:max-line-length
          // https://everforth.backlog.jp/git/APC/EverforthFramework/blob/release/src/main/scala/com/everforth/everforth/context/Reason.scala
          // l.1563 Sales Stock shortage
          return '在庫の足りない商品があるため、注文を完了できませんでした。'
        // tslint:disable-next-line:no-magic-numbers
        case 15300:
          return getPaymentErrorMessage(body['reason.detail'])
        default:
          return null
      }
    }))

    const errorMessagesByCauseType: string[] = []
    if (this.hasErrorOnCauseType(purchaseResults, 'NoItemsError')) {
      errorMessagesByCauseType.push('月々のお支払い価格が変更されているか、お申し込みがキャンセルされています。')
    }

    if (
      this.hasErrorOnCauseType(purchaseResults, 'NotInStoreError') ||
      this.hasErrorOnCauseType(purchaseResults, 'StockIsEmptyError')
    ) {
      errorMessagesByCauseType.push('在庫の足りない商品があるため、注文を完了できませんでした。')
    }
    if (
      !this.hasErrorOnCauseType(purchaseResults, 'StockIsEmptyError') &&
      this.hasErrorOnCauseType(purchaseResults, 'UnitCountExceededError')
    ) {
      errorMessagesByCauseType.push('購入上限数に達している商品があるため、注文を完了できませんでした。')
    }

    if (this.hasErrorOnCauseType(purchaseResults, 'UnapplicableCouponError')) {
      errorMessagesByCauseType.push('このご注文にはご利用いただけないクーポンが選択されています。<br />ご利用になるクーポンを変更するか、クーポンの選択を解除してください。')
    }

    if (this.hasErrorOnCauseType(purchaseResults, 'RootFkuNotPublicError')) {
      errorMessagesByCauseType.push('販売を終了した商品があるため、注文を完了できませんでした。')
    }

    if (
      this.hasErrorOnCauseType(purchaseResults, 'NoveltyItemIncludedInCartError') ||
      this.hasErrorOnCauseType(purchaseResults, 'NoveltyConstraintError')
    ) {
      errorMessagesByCauseType.push('ご利用いただけないノベルティが含まれているため、注文を完了できませんでした。')
    }

    if (this.hasErrorOnCauseType(purchaseResults, InconsistentError.errorKind)) {
      errorMessagesByCauseType.push('<br/>データ不整合のため、注文を完了できませんでした。<br/>')

      const errorResponseBodies = extractFrontErrorBodiesFromPurchaseResult(purchaseResults)
      const cartItemList = new CartItemList(this.displayCartItems)

      _.flatMap(
        errorResponseBodies,
        e => InconsistentError.buildErrorMessages(e, cartItemList)
      ).forEach((message) => {
        errorMessagesByCauseType.push(`${message}<br/>`)
      })
    }

    return [
      defaultErrorMessage,
      ...errorMessages,
      ...errorMessagesByCauseType,
    ].join('<br />')
  }

  async setCompleteData(succeedHistories: LegacyEngineSubscriptionHistory[], failed: OrderPurchaseFail[]) {
    const orderResults: OrderResult[] = buildAppliedSubscriptionRecordFromLegacyData({
      succeedHistories,
      failed,
      wholeOrderList: this.orderList,
    })
    const delivery: StoredDelivery = new DeliveryContactForOrderHistoryFromStoreDeliveryContact(
      this.deliveryContact as Required<Contact>
    )
    const payload: SetCompletedState = {
      summary: {
        paymentPrice: {
          total: this.totalPrice,
          subtotal: this.subtotalPrice,
          commission: {
            total: this.commission,
            count: this.commissionList.length,
          },
          shipping: {
            total: this.shipping,
            count: this.shippingList.length,
          },
        },
      },
      orderResults,
      delivery,
    }

    return await this.$store.dispatch('subscriptionConfirm/setCompletedState', payload)
  }

  async loadAtoneScript() {
    const result = await this.atoneScriptLoader.loadScript()

    if (result.isSome()) {
      this.modalMessage = this.atoneScriptLoader.loadErrorMessage
      this.showModal = true

      return
    }
  }

  async atoneAuthenticatedCallback(authenticationToken: string, userNo: string): Promise<void> {
    return atoneAuthenticatedCallbackFactory(
      this.user.id,
      { authenticationToken, userNo },
      async () => { /* nothing */ },
      async () => {
        this.modalMessage = this.errorMessage
        this.showModal = true

        log.error({ message: 'atone authentication failed' })
      }
    )
  }

  atoneCancelledCallback(): Promise<void> {
    return atoneCancelledCallbackFactory(this.user.id)
  }

  atoneFailedCallback(response: any): Promise<void>  {
    return atoneFailedCallbackFactory(
      this.user.id,
      response,
      async () => {
        this.modalMessage = this.errorMessage
        this.showModal = true

        log.error({ message: 'atone failed something', response })
      }
    )
  }

  async atoneSucceededCallback(response: any): Promise<void> {
    const actionOnSuccess = async () => {
      const { id } = response

      const payment =  {
        ...this.payment!,
        ...{
          paymentid: id,
          auth_token: this.user.payment_auth_token,
        },
      }

      // This callback should be fired for a single order.
      // This is for just in case, for basically the check shoud be done before this callback.
      if (this.orderList.length !== 1) {
        this.modalMessage = this.errorMessage
        this.showModal = true

        log.error({
          message: 'atone succeeded callback assumed that only one order exist, but not',
          orders: this.orderList,
        })

        return
      }

      // Set provisional id into the order
      const orders = _.cloneDeep(this.orderList)
      _.map(orders, order => order.id = this.provisionalOrderIdForSingleOrder!)

      // atoneは単一注文になっているはずなので、
      // ordersとpurchaseEstimatesは常に長さ1の配列
      // なのでマッピングは崩れない
      await this.executePurchase({
        orders,
        payment,
        purchaseEstimates: this.purchaseEstimates,
      })
    }

    return atoneSucceededCallbackFactory(this.user.id, response, actionOnSuccess)
  }

  async atoneErrorCallback(name: string, message: string, errors: any[]) {
    atoneErrorCallbackFactory(
      this.user.id,
      { name, message, errors },
      async () => {
        this.modalMessage = `${this.errorMessage}<br/><hr/>`

        if (errors) {
          _.map(errors, (error) => {
            const errorCode = _.get(error, 'code')
            const errorMessage = _.get(error, 'messages.0')
            this.modalMessage += `エラー:${errorCode} ${errorMessage}<br/>`
          })
        }

        this.showModal = true
      }
    )
  }

  async loadAndConfigPaidyScript() {
    const result = await this.paidyScriptLoader.loadScript()

    if (result.isSome()) {
      this.modalMessage = this.paidyScriptLoader.loadErrorMessage
      this.showModal = true

      return
    }

    this.paidyHandler = configPaidy(this.paidyCallback)
  }

  async paidyCallback(response: PaidyResponse): Promise<void> {
    return paidyCallbackFactory(response, this.paidyCallbackAction)
  }

  async paidyCallbackAction(response: PaidyResponse): Promise<void> {
    const { id, status } = response

    if (status === 'rejected') {
      this.modalMessage = this.errorMessage
      this.showModal = true

      log.error({ message: 'paidy payment is rejected', response })

      return
    }

    if (status !== 'authorized') {
      log.error({ message: 'paidy not authorized', response })

      return
    }

    const payment: Payment =  {
      ...this.payment!,
      ...{
        paymentid: id,
      },
    }

    // This callback should be fired for a single order.
    // This is for just in case, for basically the check shoud be done before this callback.
    if (this.orderList.length !== 1) {
      this.modalMessage = this.errorMessage
      this.showModal = true

      log.error({
        message: 'paidy callback assumed that only one order exist, but not',
        orders: this.orderList,
      })

      return
    }

    // This is for just in case, for basically the check shoud be done before this callback.
    if (!this.provisionalOrderIdForSingleOrder) {
      this.modalMessage = this.errorMessage
      this.showModal = true

      log.error({
        message: 'paidy callback require provisional order id exist, but not',
      })

      return
    }

    // Set provisional id into the order
    const orders = this.orderList.map(order => ({
      ...order,
      ...{
        id: this.provisionalOrderIdForSingleOrder!,
      },
    }))

    // paidyは単一注文になっているはずなので、
    // ordersとpurchaseEstimatesは常に長さ1の配列
    // なのでマッピングは崩れない
    await this.executePurchase({
      orders,
      payment,
      purchaseEstimates: this.purchaseEstimates,
    })
  }

  async processPaidy(): Promise<void> {
    if (!Paidy) {
      this.modalMessage = this.paidyScriptLoader.loadErrorMessage
      this.showModal = true

      return
    }

    await this.createProvisionalOrderIdForSingleOrderIfNotExist()

    if (!this.provisionalOrderIdForSingleOrder) {
      this.modalMessage = this.errorMessage
      this.showModal = true

      log.error({
        message: 'paidy process require provisional order id exist, but not',
      })

      return
    }

    // 2025/04時点で定期購入とサービス手数料が同時に有効になるサービスは存在しない
    const items = convertCartItemsForPaidy(this.cartItems, this.discountAmount)

    const payload = makePaidyPayload(
      this.provisionalOrderIdForSingleOrder,
      this.user,
      this.deliveryContact!,
      items,
      this.shipping
    )

    this.paidyHandler.launch(payload)
  }

  async loadCreditcardScript() {
    await this.cardPaymentProvider.loadScript()
      .catch(() => {
        this.modalMessage = this.errorMessage
        this.showModal = true

        log.error({
          message: 'failed to load creditcard script',
        })
      })
  }

  // クロネコ決済の場合、決済トークンが注文毎に変わるので商品購入を直列に実行する。
  // 途中で失敗したら途中までの処理結果を返すので、
  // OrderPurchaseResultの数とOrderItemの数が必ずしも一致しない。
  async processCreditcard(): Promise<void> {
    const createPayment = this.createCreditcardPayment().then(
      result => result.fold(
        error => Promise.reject(error),
        cardPayment => Promise.resolve(cardPayment)
      )
    ).catch((error) => {
      this.modalMessage = [
        'クレジットカード決済情報の取得中にエラーが発生したため、決済を中止しました。',
        '決済手続きは完了しておりません。',
        '※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。',
      ].join('<br>')
      this.showModal = true

      return Promise.reject(new Error(`failed to create payment for credit card due to ${error}`))
    })

    const payment = await createPayment

    return await this.executePurchase({
      orders: this.orderList,
      payment,
    })
  }

  async createCreditcardPayment(): Promise<Either<Error, CreditcardPayment>> {
    const paymentResult = await this.cardPaymentProvider.createPaymentPayload(
      {
        id: this.payment!.token!,
        lastCreditDate: this.payment!.lastCreditDate!,
        securityCode: this.securityCode,
        numberLast4: this.payment!.numberLast4!,
        cardType: this.payment!.cardType!,
      },
      this.user
    )
    if (paymentResult.isLeft()) {
      return new Left(paymentResult.value)
    }

    const payment = paymentResult.value

    return new Right({
      ...payment,
      ...parametersWhichAreRequiredByEngineForSubscription,
    })
  }

  async processPurchaseDefault(): Promise<void> {
    await this.executePurchase({ orders: this.orderList })
  }

  /**
   * 初期化前に各種データの状態をチェックし、不完全ならリダイレクト.
   *
   * @return リダイレクトが発生した時はLeft,リダイレクトが発生しなかった時はRight
   */
  async guardBeforeInitialize(): Promise<Either<Location, null>> {
    try {
      const baseParam = {
        scope: this.scope,
        context: this.context,
      }
      const redirectList: Array<Location | void> = await Promise.all([
        guardOnCart({
          ...baseParam,
          redirectLocation: () => ({
            path: this.brandTopPage,
          }),
          filter: isSubscriptionApplicable,
        }),
        guardOnUser({ ...baseParam, to: this.$route }),
        guardOnDelivery(baseParam),
      ])

      for (const redirect of redirectList) {
        if (redirect) {
          this.$router.push(redirect)

          return left(redirect)
        }
      }

      return right(null)
    } catch (error) {
      this.modalMessage = this.errorMessage
      this.showModal = true

      log.error('error on guard before initialize')

      throw error
    }
  }

  beforeRouteLeave(_to, _from, next) {
    this.setReplacedForSale(false)
    next()
  }

  shouldReload(purchaseResults: OrderPurchaseResult[]): boolean {

    return this.hasErrorOnCauseType(purchaseResults, 'ItemPriceChangedError')
  }

  hasErrorOnCauseType(results: OrderPurchaseResult[], errorType: string): boolean {
    const errorBodies = extractFrontErrorBodiesFromPurchaseResult(results)

    if (errorBodies.length === 0) {
      return false
    }

    const errorBodiesCauseTypes = _.compact(
      errorBodies.map(body =>
        _.map(body.cause, cause => (cause.match(/\[(.+?)\]/) || [])[1])
      )
    )

    return _.some(errorBodiesCauseTypes, errorCauseTypes => _.includes(errorCauseTypes, errorType))
  }

  closeModal() {
    this.showModal = false
  }

  private redirectToPaymentIfNeed(results: OrderPurchaseResult[]): boolean {
    // 注文完了後に呼ばれるので決済種別は必ずあることを期待する
    if (!this.paymentType) {
      return false
    }

    return createRedirectHtmlRenderer(
      this.paymentType,
      results.map(r => convertFromOrderPurchaseResult(r))
    ).render()
  }
}

enum Status {
  Pending,
  Loading,
  Failed,
  Completed,
}
